import React, { useEffect, useState } from "react";
import WhiteLogo from "../../assets/svg/dash-logo.svg";
import DashMobLogo from "../../assets/svg/dash-mob-mid.svg";
import HospiMobLogo from "../../assets/svg/mob-hospi.svg";
import WellnessMobLogo from "../../assets/svg/mob-wellness.svg";
import CompMobLogo from "../../assets/svg/mob-comp.svg";
import SupportMobLogo from "../../assets/svg/support-mob.svg";
import TermMobLogo from "../../assets/svg/term-mob.svg";
import LogoutMobLogo from "../../assets/svg/logout-mob.svg";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { useNavigate } from "react-router-dom";
import ROUTE_PATH from "../../constant/route";
import PrimaryButton from "../../components/Button/PrimaryButton";
import { Modal } from "../../components/Modal";
import { useDispatch, useSelector } from "react-redux";
import { handleCustomerDetail } from "../../store/reducers/authentication/apiThunk";
import { updateUserData } from "../../store/reducers/authentication";
import { showToast } from "../../components/Toast";
import { AppDispatch } from "../../store/store";
import VideoModal from "../Login/VideoModal";
import PlayCircleFilledWhiteOutlinedIcon from "@mui/icons-material/PlayCircleFilledWhiteOutlined";

const MobileDashboard = () => {
  const dispatch = useDispatch<AppDispatch>();
  const reduxDetail = useSelector((state: any) => state?.authentication);
  const {
    login: { mobileNo = "" },
  } = reduxDetail;
  const [openLogout, setOpenLogout] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [userDetail, setUserDetail] = useState<any>({});
  const currentUrl = window.location.href;
  const isCoversure = currentUrl.includes("https://users.coversure.in");
  const websiteUrl = isCoversure
    ? "https://www.coversure.in/"
    : "https://www.coversure.click/";
  const navigate = useNavigate();
  const [isOpen, setOpen] = useState(false);
  const [link, setLink] = useState("");
  function handleChange() {
    setOpen(!isOpen);
  }
  const handleUserDetail = async () => {
    const mob = {
      mobileNo: mobileNo,
    };

    try {
      const resCustomer = await dispatch(handleCustomerDetail(mob)).unwrap();
      if (resCustomer?.status === 1) {
        setUserDetail(resCustomer?.data?.customerDetails[0]);
        dispatch(updateUserData(resCustomer?.data?.customerDetails));
      }
    } catch (error) {
      showToast("Something went wrong", "error");
      console.error("Error saving user data:", error);
    }
  };

  useEffect(() => {
    handleUserDetail();
  }, []);
  const handleClickOpenLogout = () => {
    setOpenLogout(true);
  };
  const handleCloseLogout = () => {
    setOpenLogout(false);
  };
  useEffect(() => {
    // Function to update window width
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    // Add event listener to update width on window resize
    window.addEventListener("resize", handleResize);

    // Cleanup function to remove event listener
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    if (windowWidth > 600) {
      navigate(ROUTE_PATH.WELLNESS);
    }
  }, [windowWidth]);

  return (
    <>
      <div className="w-[100%] h-[100vh] bg-bg-color-8 flex flex-col justify-between">
        <div>
          <div className="bg-bg-color-9 p-[32px] rounded-bl-[30px] rounded-br-[30px] shadow-custom-light flex flex-col items-center justify-center">
            <img
              src={WhiteLogo}
              alt="WhiteLogo"
              style={{
                width: "200px",
              }}
            />
            <div className="text-[16px] leading-[20px] font-bold text-white mt-[20px] mb-[40px]">
              Hi,{" "}
              {userDetail?.firstName
                ? userDetail?.firstName + " " + userDetail?.lastName
                : ""}
            </div>
            <img src={DashMobLogo} alt="DashMobLogo" />
            <div className="text-[20px] leading-[20px] font-bold text-white mt-[21px]">
              Your subscriptions
            </div>
          </div>
          <div className="p-[16px] pt-[30px]">
            {/* <div className="w-[100%]  flex items-center justify-between">
          <div
            className="w-[48%] bg-white shadow-custom-light rounded-[14px] py-[16px] px-[10px] "
            onClick={() => {
              navigate(ROUTE_PATH.HOSPICASH);
            }}
          >
            <div className="flex items-center justify-between mb-[25px]">
              <img src={HospiMobLogo} alt="HospiMobLogo" />
              <ArrowForwardIcon style={{ fontSize: "20px" }} />
            </div>
            <div className="text-[11px] leading-[18px] font-bold">
              Hospicash Insurance
            </div>
          </div>
          <div
            className="w-[48%] bg-white shadow-custom-light rounded-[14px] py-[16px] px-[10px] "
            onClick={() => {
              navigate(ROUTE_PATH.WELLNESS);
            }}
          >
            <div className="flex items-center justify-between mb-[25px]">
              <img src={WellnessMobLogo} alt="WellnessMobLogo" />
              <ArrowForwardIcon style={{ fontSize: "20px" }} />
            </div>
            <div className="text-[11px] leading-[18px] font-bold">
              Wellness Benefits
            </div>
          </div>
        </div> */}
            <div
              className="w-[100%] bg-white shadow-custom-light rounded-[14px] py-[16px] px-[10px] mt-[13px]"
              onClick={() => {
                navigate(ROUTE_PATH.WELLNESS);
              }}
            >
              <div className="flex items-center justify-between">
                <div className="text-[11px] leading-[18px] font-bold flex items-center">
                  <img
                    src={WellnessMobLogo}
                    alt="WellnessMobLogo"
                    style={{ marginRight: "8px" }}
                  />{" "}
                  Wellness Benefits
                </div>
                <ArrowForwardIcon style={{ fontSize: "20px" }} />
              </div>
            </div>
            {/* <div
          className="w-[100%] bg-white shadow-custom-light rounded-[14px] py-[16px] px-[10px] mt-[13px]"
          onClick={() => {
            navigate(ROUTE_PATH.COMPREHENSIVE);
          }}
        >
          <div className="flex items-center justify-between">
            <div className="text-[11px] leading-[18px] font-bold flex items-center">
              <img
                src={CompMobLogo}
                alt="CompMobLogo"
                style={{ marginRight: "8px" }}
              />{" "}
              Coversure Platform
            </div>
            <ArrowForwardIcon style={{ fontSize: "20px" }} />
          </div>
        </div> */}
          </div>
        </div>
        <div>
          <div className="flex w-[100%]">
            <div className="w-[50%] flex flex-col justify-center items-end mr-[10px] ">
              <div
                className="w-fit cursor-pointer"
                onClick={() => {
                  setLink("https://www.youtube.com/watch?v=kJVSGNRp29w");
                  handleChange();
                }}
              >
                <div className="mt-[12px] w-[100%] text-center">
                  <PlayCircleFilledWhiteOutlinedIcon
                    style={{
                      color: "#0040FF",
                      marginRight: "10px",
                    }}
                  />
                  <span className="text-text-color-9 underline text-[13px] lg:text-[16px]">
                    See how it works
                  </span>
                </div>
              </div>
            </div>
            <div className="w-[50%] flex flex-col justify-center items-start ml-[10px] ">
              <div
                className="w-fit cursor-pointer"
                onClick={() => {
                  setLink("https://www.youtube.com/watch?v=N9UAo7ZF3jo");
                  handleChange();
                }}
              >
                <div className="mt-[12px] w-[100%] text-center">
                  <PlayCircleFilledWhiteOutlinedIcon
                    style={{
                      color: "#0040FF",
                      marginRight: "10px",
                    }}
                  />
                  <span className="text-text-color-9 underline text-[13px] lg:text-[16px]">
                    कैसे उपयोग करे
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="flex items-center justify-evenly pb-[30px] mt-[10px]">
            <div
              className="flex items-center text-[12px] leading-[12px] font-medium cursor-pointer"
              onClick={() => {
                window.scrollTo(0, 0);
                navigate(ROUTE_PATH.SUPPORT);
              }}
            >
              <img
                src={SupportMobLogo}
                alt="SupportMobLogo"
                style={{ marginRight: "5px" }}
              />{" "}
              Support
            </div>
            <div
              className="text-[12px] leading-[12px] font-medium"
              style={{ color: "#2A31402B" }}
            >
              |
            </div>
            <div
              className="flex items-center text-[12px] leading-[12px] font-medium cursor-pointer"
              onClick={() => {
                // window.scrollTo(0, 0);
                // navigate(ROUTE_PATH.TERM_CONDITION);
                window.open(
                  `${websiteUrl}prosure`,
                  "_blank",
                  "noopener,noreferrer"
                );
              }}
            >
              <img
                src={TermMobLogo}
                alt="TermMobLogo"
                style={{ marginRight: "5px" }}
              />{" "}
              T&C
            </div>
            <div
              className="text-[12px] leading-[12px] font-medium"
              style={{ color: "#2A31402B" }}
            >
              |
            </div>
            <div
              className="flex items-center text-[12px] leading-[12px] font-medium cursor-pointer"
              onClick={handleClickOpenLogout}
            >
              <img
                src={LogoutMobLogo}
                alt="LogoutMobLogo"
                style={{ marginRight: "5px" }}
              />{" "}
              Logout
            </div>
          </div>
        </div>
        <Modal
          open={openLogout}
          handleClose={handleCloseLogout}
          content={
            <div className="max-w-[300px] p-[30px] flex flex-col items-center justify-center">
              <div className="text-[24px] leading-[28px] font-semibold font-poppins">
                Are you sure?
              </div>
              <div className="text-[14px] leading-[18px] font-medium text-text-color-3 text-center pt-[5px] font-poppins">
                You’re about to log out. Make sure to save any changes before
                you go.
              </div>
              <div className="flex items-center justify-between w-[100%]">
                <PrimaryButton
                  label={
                    <div className="flex items-center justify-center w-[100%] font-black">
                      <div className="text-[14px] leading-[18px] lg:text-[18px] lg:leading-[18px] text-text-color-3">
                        Cancel
                      </div>
                    </div>
                  }
                  onClick={handleCloseLogout}
                  classname="w-[45%] mx-auto mt-[40px]"
                  style={{ backgroundColor: "#E5E5E5" }}
                />
                <PrimaryButton
                  label={
                    <div className="flex items-center justify-center w-[100%] font-black">
                      <div className="text-[14px] leading-[18px] lg:text-[18px] lg:leading-[18px] ">
                        Logout
                      </div>
                    </div>
                  }
                  classname="w-[45%] mx-auto mt-[40px]"
                  style={{ backgroundColor: "#F04438" }}
                  onClick={() => {
                    window.localStorage.clear();
                    window.sessionStorage.clear();
                    window.location.href = "/";
                  }}
                />
              </div>
            </div>
          }
        />
      </div>
      <VideoModal isOpen={isOpen} close={handleChange} videoUrl={link} />
    </>
  );
};

export default MobileDashboard;
